import CountryMap from "./CountryMap.json"

export type CountryCode = keyof typeof CountryMap
const CountryCodes = Object.keys(CountryMap) as CountryCode[]
export { CountryMap, CountryCodes }
